// member-portal/src/components/Report.js — FIXED: Last Month data now displays correctly
import React, { useState, useEffect, useCallback } from 'react';
import './Report.css';
import NavButtons from './NavButtons';
import { FaSync } from 'react-icons/fa';

const Report = ({ user, navigateTo, goBack }) => {
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchReports = useCallback(async (forceRefresh = false) => {
    if (!user || !user.token) return;
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/members/reports${forceRefresh ? '?refresh=true' : ''}`,
        {
          headers: { 'Authorization': `Bearer ${user.token}` },
        }
      );
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.error || `HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('Fetched report data:', data); // Debug log
      setReport(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching report:', err);
      setReport([]);
      setError(err.message || 'Failed to load report data');
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  const handleRefresh = () => {
    fetchReports(true);
  };

  const calculateTotals = (period) => {
    if (!Array.isArray(report) || report.length === 0) {
      return { displayed: 0, views: 0, clicks: 0 };
    }
    return report.reduce(
      (acc, item) => ({
        displayed: acc.displayed + (item[period]?.displayed || 0),
        views: acc.views + (item[period]?.views || 0),
        clicks: acc.clicks + (item[period]?.clicks || 0),
      }),
      { displayed: 0, views: 0, clicks: 0 }
    );
  };

  const currentTotals = calculateTotals('currentMonth');
  const lastTotals = calculateTotals('lastMonth');

  return (
    <div className="report">
      <NavButtons navigateTo={navigateTo} user={user} activePage="report" />
      <div className="report-header">
        <h2>Engagement Reports</h2>
        <button className="refresh-button" onClick={handleRefresh} disabled={loading} title="Refresh Reports">
          <FaSync className={loading ? 'spinning' : ''} />
        </button>
      </div>
      {loading ? (
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading report data...</p>
        </div>
      ) : error ? (
        <p className="error">{error}</p>
      ) : report.length === 0 ? (
        <p>No engagement reports available yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th rowSpan="2">Deal Title</th>
              <th colSpan="3">Current Month</th>
              <th colSpan="3">Last Month</th>
            </tr>
            <tr>
              <th>Displayed</th>
              <th>Views</th>
              <th>Clicks</th>
              <th>Displayed</th>
              <th>Views</th>
              <th>Clicks</th>
            </tr>
          </thead>
          <tbody>
            {report.map((item, index) => (
              <tr key={index}>
                <td className="deal-title">{item.dealTitle || 'Unknown Deal'}</td>
                <td>{(item.currentMonth?.displayed || 0).toLocaleString()}</td>
                <td>{(item.currentMonth?.views || 0).toLocaleString()}</td>
                <td>{(item.currentMonth?.clicks || 0).toLocaleString()}</td>
                <td>{(item.lastMonth?.displayed || 0).toLocaleString()}</td>
                <td>{(item.lastMonth?.views || 0).toLocaleString()}</td>
                <td>{(item.lastMonth?.clicks || 0).toLocaleString()}</td>
              </tr>
            ))}
            <tr className="totals-row">
              <td><strong>Totals</strong></td>
              <td><strong>{currentTotals.displayed.toLocaleString()}</strong></td>
              <td><strong>{currentTotals.views.toLocaleString()}</strong></td>
              <td><strong>{currentTotals.clicks.toLocaleString()}</strong></td>
              <td><strong>{lastTotals.displayed.toLocaleString()}</strong></td>
              <td><strong>{lastTotals.views.toLocaleString()}</strong></td>
              <td><strong>{lastTotals.clicks.toLocaleString()}</strong></td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Report;